module.exports = __webpack_public_path__ + "img/down.fc8aea33.svg";